import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState } from 'react'
import Swal from 'sweetalert2';
import request from '../../../../Helpers/API';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { LoaderScreen } from '../../../components/LoaderScreen';

export const DescargarConvenioModal = ({ open, onClose, folio }) => {

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const onImprimirConvenioPago = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`DetalleClienteGestionarConvenios/ReportePDF?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();

                const linkSource = `data:application/pdf;base64, ${result.documento}`;
                const downloadLink = document.createElement("a");
                const fileName = `${result.nombredocumento}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    };

    const onDescargar = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ConvenioPago/ObtenerDocumento?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();

                const linkSource = result.documento;
                const downloadLink = document.createElement("a");
                const fileName = `Evidencia-${folio}.${result.extension}`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                Swal.fire("DESCARGAR EVIDENCIA", JSON.stringify(error), "error");
            });
    };

    return (
        <Modal open={open}>
            <div className="modal-descarga-archivos-convenio-pago-modal-main">
                <LoaderScreen loader={loader} />
                <div className="convenio-pago-descargar-archivos-modal-title">
                    {/* <Agriculture
              color="primary"
              style={{ textAlign: "center", fontSize: 50 }}
            /> */}
                    <div className="filtro-soy-el-titulo-header">
                        <h3>DESCARGA DE ARCHIVOS</h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>


                <div className="descargar-archivos-convenio-pago-opciones-container">
                    <div className='descargar-archivos-convenio-pago-opcion-1' >
                        CONVENIO DE PAGO

                        <button className='descargar-archivos-convenio-pago-opcion-1-button' onClick={() => onImprimirConvenioPago()}>
                            <CloudDownloadIcon />Descargar
                        </button>

                    </div>

                    <div className='descargar-archivos-convenio-pago-opcion-2' >
                        EVIDENCIA

                        <button className='descargar-archivos-convenio-pago-opcion-2-button' onClick={() => onDescargar()}>
                            <CloudDownloadIcon />Descargar
                        </button>

                    </div>

                </div>

                <div className="descargar-archivos-convenio-pago-button-container ">
                    <Button onClick={onClose} variant="contained" color="error">
                        Cerrar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
